import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Container, Grid, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Navbar from '../../../components/NavBar/NavBar';
import Footer from '../../../components/Footer/Footer';
import { Banner, BannerText, BannerLogo } from '../../../styles/Banner';
import { termos } from '../../../constants/Institucional/termos';
import NavLinkItem from '../QuemSomos/NavLinksItem';

const Termos = () => {
    const [busca, setBusca] = useState('');
    const termosFiltrados = termos.filter(p =>
        p.topico.toLowerCase().includes(busca.toLowerCase()) ||
        p.paragrafos.some(paragrafo =>
        paragrafo.toLowerCase().includes(busca.toLowerCase())
    )
    );
        return (
            <>  
                <Navbar />
                <div>
                    <Banner>
                        <BannerText>
                        <p>
                            <a href="https://www.meucupom.com/" target='_blank' rel="noreferrer">Home</a> &gt; Institucional &gt; Termos de uso
                        </p>
                        <Typography variant='h2'
                        >Termos de uso</Typography>

                        <TextField
                            placeholder="Pesquise..."
                            variant="outlined"
                            size="medium"
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                            sx={{
                                mt: 2,
                                backgroundColor: "#fff",
                                borderRadius: "50px",
                                width: "100%",
                                maxWidth: {
                                    xs: 300, 
                                    sm: 400, 
                                    md: 600, 
                                },
                                "& .MuiOutlinedInput-root": {
                                    "& fieldset": { borderColor: "transparent" },
                                    "&:hover fieldset": { borderColor: "#ffcc00" },
                                    "&.Mui-focused fieldset": { borderColor: "#ffcc00" }
                                }
                            }}
                            
                        />
                            <NavLinkItem to="/institucional/politica-de-privacidade" label="POLÍTICA DE PRIVACIDADE" />
                        </BannerText>
                        <BannerLogo>
                            <img 
                                src="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/logo-negative.png" 
                                alt="MeuCupom Logo" 
                            />
                        </BannerLogo>
                    </Banner>
                    <Container maxWidth="lg" sx={{ py: 4 }}>
                        <Typography 
                        variant="h4" 
                        sx={{
                            marginBottom: '3rem',
                            fontSize: { xs: '1.8rem', sm: '2rem', md: '2.5rem' } 
                        }}>
                        Termos de uso
                        </Typography>
                        <Grid container spacing={2}>
                        <Grid item xs={12}>
                        {termosFiltrados.length > 0 ? (
                            termosFiltrados.map((termo, index) => (
                                <Accordion key={index}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index}-content`}
                                    id={`panel${index}-header`}
                                    sx={{
                                    minHeight: 80,
                                    '& .MuiAccordionSummary-content': {
                                        margin: '20px 0',
                                    },
                                    }}
                                >
                                    <Typography variant="h6" sx={{ textTransform: 'uppercase' }}>{termo.topico}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                {termo.paragrafos.map((p, i) => (
                                    <Typography key={i} paragraph>
                                    {p}
                                    </Typography>
                                ))}
                                </AccordionDetails>
                                </Accordion>
                            ))
                            ) : (
                            <Typography variant="body1">Nenhum Termo encontrado.</Typography>
                        )}
                            
                        </Grid>
                        </Grid>
                    </Container>
                </div>
                <Footer/>
            </>
        );
};
export default Termos;